module.exports = "https://static.zego.com/_next/static/images/van-f3fbaec2c61cbae9707a45a4222428ea.svg";